// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Emotion from "../../bindings/Emotion.bs.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as JsxRuntime from "react/jsx-runtime";

let pulse = Emotion.Css.keyframes({
  "0%": {
    opacity: "1"
  },
  "50%": {
    opacity: "0.4"
  },
  "100%": {
    opacity: "1"
  }
});

function barClass(width, height, radius, className) {
  return Emotion.Css.cx([
    Emotion.Css.css({
      display: "block",
      width: width,
      height: height,
      borderRadius: radius,
      backgroundColor: Emotion.Utils.Color.bgElevated,
      animation: pulse + " 1.4s ease-in-out infinite"
    }),
    className
  ]);
}

function Skeleton$Skeleton(props) {
  let __className = props.className;
  let height = props.height;
  let width = props.width;
  let __variant = props.variant;
  let variant = __variant !== undefined ? __variant : "line";
  let className = __className !== undefined ? __className : "";
  let match = variant === "circle" ? [
      "2.5rem",
      "2.5rem",
      Emotion.Utils.Border.getRadius("full")
    ] : (
      variant === "title" ? [
          "60%",
          "1.5rem",
          Emotion.Utils.Border.getRadius("sm")
        ] : (
          variant === "block" ? [
              "100%",
              "6rem",
              Emotion.Utils.Border.getRadius("md")
            ] : [
              "100%",
              "0.75rem",
              Emotion.Utils.Border.getRadius("sm")
            ]
        )
    );
  return JsxRuntime.jsx("span", {
    "aria-hidden": true,
    className: barClass(width !== undefined ? width : match[0], height !== undefined ? height : match[1], match[2], className)
  });
}

function Skeleton$Skeleton$Stack(props) {
  let __className = props.className;
  let __count = props.count;
  let count = __count !== undefined ? __count : 3;
  let className = __className !== undefined ? __className : "";
  let lines = Stdlib_Array.fromInitializer(count, i => i);
  return JsxRuntime.jsx("div", {
    children: lines.map(i => {
      let width = i === (count - 1 | 0) ? "72%" : "100%";
      return JsxRuntime.jsx("span", {
        "aria-hidden": true,
        className: barClass(width, "0.75rem", Emotion.Utils.Border.getRadius("sm"), "")
      }, i.toString());
    }),
    className: Emotion.Css.cx([
      Emotion.Css.css({
        display: "flex",
        flexDirection: "column",
        gap: "0.65rem"
      }),
      className
    ])
  });
}

let Stack = {
  make: Skeleton$Skeleton$Stack
};

let Skeleton = {
  pulse: pulse,
  barClass: barClass,
  make: Skeleton$Skeleton,
  Stack: Stack
};

export {
  Skeleton,
}
/* pulse Not a pure module */
